import React from 'react';
import {Dropdown, Menu, Button, Upload} from "antd";
import ButtonGroup from "antd/es/button/button-group";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "../../../../../utils/message";

/**
 * creat by xcc
 * @description 批量导入
 */

export default class BatchImport extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        isAssignment: false
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    renderUpload() {
        return (
            <>
                <Upload accept={".xlsx,.xls"}
                        showUploadList={false}
                        beforeUpload={this.beforeUpload}
                        customRequest={({file}) => {
                            this.import(file)
                        }}
                >
                    批量导入
                </Upload>
            </>
        )
    }

    beforeUpload = (file) => {
        let type;
        if (file) {
            let index = file.name.lastIndexOf(".");
            type = file.name.slice(index);
        }
        const isJpgOrPng = type === '.xlsx' || type === '.xls';
        if (!isJpgOrPng) {
            message.warn('仅支持上传xlsx、xls文件！');
        }
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!isLt2M) {
            message.warn('文件必须小于100M！');
        }
        return isJpgOrPng && isLt2M;
    }

    import(file) {
        const {isAssignment} = this.props;
        let batchType = isAssignment ? 2 : 1;
        let url = "/cm-sites-media-consumer/batch/importTempPosition";
        let fd = new FormData();
        fd.append("multipartFile", file);
        fd.append("batchType", batchType);
        window.loading.show();
        this.request({
            url,
            body: fd,
            method: "post",
            contentType: "upload",
            loading: false,
            callBack: (data, status) => {
                if (status === 200) {
                    this.batchVerify()
                } else {
                    window.loading.hide();
                    message.warn("批量导入失败");
                }
            }, errorCallBack: () => {
                window.loading.hide();
            }, serverVerify: {
                serverErrorCallBack: () => {
                    window.loading.hide();
                }
            }
        });
    }

    timer;

    batchVerify() {
        const {refreshList} = this.props;
        this.request({
            url: "/cm-sites-media-consumer/batch/importProcess",
            body: {account: window.currentUser.id},
            loading: false,
            callBack: (data, status) => {
                if (data) {
                    if (data.status === "进行中") {
                        this.timer = setTimeout(() => {
                            this.batchVerify();
                        }, 2000)
                    } else if (data.status === "导入异常") {
                        window.loading.hide();
                        message.warn(data.msg);
                    } else if (data.status === "已完成") {
                        window.loading.hide();
                        message.success("批量导入成功");
                        refreshList();  //刷新列表
                    }
                } else {
                    message.warn("批量导入失败");
                    window.loading.hide();
                }
            }, errorCallBack: () => {
                window.loading.hide();
            }, serverVerify: {
                serverErrorCallBack: () => {
                    window.loading.hide();
                }
            }
        });
    }

    getMenu() {
        return (
            <Menu id={"menu"}>
                <Menu.Item>
                    {this.renderUpload()}
                </Menu.Item>
                <Menu.Item onClick={() => {
                    this.downLoadTemplate()
                }}><span style={{paddingLeft: 10}}>下载模板</span></Menu.Item>
                <style>{`
                    #menu .ant-dropdown-menu-item{padding: 5px 0px;}
                    #menu .ant-upload.ant-upload-select>span{display: inline-block;width: 100px;padding-left: 10px;}
                `}</style>
            </Menu>
        )
    }

    downLoadTemplate() {
        const {isAssignment} = this.props;
        this.request({
            url: "/cm-sites-media-consumer/batch/outputTemplate",
            body: {batchType: isAssignment ? 2 : 1},
            method: "downloadGet",
            callBack: (data) => {
            },
            errorCallBack: () => {
            },
            serverVerify: {
                serverErrorCallBack: () => {
                }
            }
        });
    }

    render() {
        const menu = this.getMenu();
        return (
            <>
                <div id={"dropdownBtn"}>
                    <Dropdown overlay={menu} placement="bottomLeft">
                        <ButtonGroup>
                            <Button type={"primary"}>批量导入</Button>
                            <Button type={"primary"} icon="ellipsis"/>
                        </ButtonGroup>
                    </Dropdown>
                </div>
                <style>{`#dropdownBtn .ant-btn.ant-btn-primary.ant-btn-icon-only{padding: 0px 10px 0px 0px;}
                    #dropdownBtn .ant-btn.ant-btn-primary{padding: 0px 0px 0px 10px;}
                `}</style>
            </>
        )
    }
}